































































































































































import BtnDefault from '@/components/UI/BtnDefault.vue';
import {Component, Vue, Watch} from 'vue-property-decorator';
import DialogFooter from '@/components/UI/DialogFooter.vue';
import Alert from '@/components/UI/Alert.vue';
import {namespace} from 'vuex-class';
import ICheck from '@/components/icons/ICheck.vue'

const dialog = namespace('dialog')
const forms = namespace('forms')
const newshards = namespace('newshards')
const locale = namespace('locale')
const workspace = namespace('workspace')

@Component({
  components: {
    BtnDefault,
    DialogFooter,
    Alert,
    'i-check': ICheck,
  },
  name: "ExportAllForm"
})
export default class ExportAllForm extends Vue {

  @dialog.Getter('fullDialogShow') protected fullDialogShow: any
  @dialog.Mutation('SetFullDialogShow') protected SetFullDialogShow: any
  @dialog.Mutation('SetTitleDialog') protected SetTitleDialog: any
  @dialog.Mutation('SetFullPlanShow') protected SetFullPlanShow: any
  @forms.Getter('options') protected options:any
  @newshards.Action('getCountShards') protected getCountShards: any
  @newshards.Action('exportAllShardsCompany') protected exportAllShardsCompany: any
  @newshards.Action('getAdditionPaid') protected getAdditionPaid: any
  @newshards.Getter('countShards') protected countShards: any
  // @newshards.Getter('loadingCountShards') protected loadingCountShards: any
  @newshards.Getter('additionPaid') protected additionPaid: any
  @locale.Getter('getLocale') protected getLocale:any
  @workspace.Getter('getPlan') protected getPlan: any

  isFirst:boolean = true
  loading:boolean = false
  checkedEmail:boolean = true
  isError:boolean = false
  email:string = ''
  currentFormat:any = {
    title: 'AmoCRM (.csv)',
    img: '/img/exportShards/amocrm.png',
    isFile: false,
    isActive: true,
    id: 'amo',
    format: 'csv'
  }
  workspace: string = ''

  changeEmail(){
   this.checkedEmail = true
  }

  get formats() {
    return [
      {
        title: 'AmoCRM (.csv)',
        img: '/img/exportShards/amocrm.png',
        isFile: false,
        id: 'amo',
        format: 'csv'
      },
      {
        title: 'ZohoCRM (.csv)',
        img: '/img/exportShards/zoho.png',
        isFile: false,
        id: 'zoho',
        format: 'csv'
      },
      {
        title: 'Salesforce (.csv)',
        img: '/img/exportShards/salesforce.png',
        isFile: false,
        id: 'salesforce',
        format: 'csv'
      },
      {
        title: 'Битрикс (.csv)',
        img: '/img/exportShards/bitrix.png',
        isFile: false,
        id: 'bitrix',
        format: 'csv'
      },
      {
        title: 'Excel',
        img: '/img/exportShards/excel.png',
        isFile: true,
        id: 'excel',
        format: 'excel'
      },
      {
        title: this.$t('newShardList.export.exportPdf'),
        img: '/img/exportShards/pdf.png',
        isFile: true,
        id: 'pdf',
        format: 'pdf'
      },
    ]
  }

  get count() {
    let sum = 0
    for(let key in this.countShards.data) {
      sum += this.countShards.data[key]
    }
    return sum
  }

  @Watch('fullDialogShow')
  setExport() {
    this.isFirst = true
    this.loading = false
    this.checkedEmail = true
    this.isError = false
    this.email = ''
    this.currentFormat = {
      title: 'AmoCRM (.csv)',
      img: '/img/exportShards/amocrm.png',
      isFile: false,
      isActive: true,
      id: 'amo',
      format: 'csv'
    }
  }

  mounted() {
    this.getCountShards({
      companyCode: this.$route.params.code,
      showCode: this.$route.params.showCode
    })
    if(this.getPlan == 'free') {
      this.getAdditionPaid({
        companyCode: this.$route.params.code,
        showCode: this.$route.params.showCode
      })
    }
  }

  selectFormat(format:any) {
    if(format.id != 'other'){
      this.currentFormat = format
    }
  }

  async next() {
    this.SetTitleDialog(this.$t('newShardList.export.titleSecond'))
    this.isFirst = false
  }

  prev() {
    this.SetTitleDialog(this.$t('newShardList.export.titleFirst'))
    this.isFirst = true
    this.checkedEmail = true
    this.isError = false
  }

  async sendToMail() {
    this.loading = true
    this.checkEmail()
    if(this.checkedEmail) {
      let response = await this.exportAllShardsCompany({
        helper:this.options.export,
        query: {
          format: this.currentFormat.format,
        },
        params: {
          companyCode: this.$route.params.code,
          showCode: this.$route.params.showCode
        },
        body: {
          email: this.email,
        },
        message: this.$t('newShardList.export.message.first') + this.email + '. ' + this.$t('newShardList.export.message.second')
      })
      if(response) {
        this.isError = false
        this.SetFullDialogShow(false)
      } else {
        this.isError = true
        this.loading = false
      }
    }
  }

  checkEmail() {
    if(this.email !== ''){
      const re = /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
      if(re.test(String(this.email).toLowerCase())){
        this.checkedEmail = true
      }else {
        this.checkedEmail = false
        this.loading = false
      }
    }else {
      this.checkedEmail = false
      this.loading = false
    }
  }

  
  showPlans() {
    this.SetFullPlanShow(true)
  }

}
